/* WordUp Studios in three steps (sections/wordup-studios-steps.liquid).
   1 Stil: collection cards (with a little print each) and the variants. 2 Text: the fields, the dice and the ideas.
   3 Tröja: colour (the shirt turns around when it changes), size, quantity, gift. Then the cart, with a small celebration.
   The collections, the drawing and the print file come from assets/wordup-definition.js (window.WordUpDefinition), so
   the preview and the printed file are drawn by the same code as on the home page.
   The camera: in step 2 (or with the zoom button) the shirt zooms in on what is written, so it can be read on a phone.
   Phones while writing: the studio is pinned to the visible part of the screen above the keyboard (.is-typing), the
   shirt on top and the field under it. Without that, iOS scrolls the page and the sticky shirt leaves the screen. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var noop = function () {};

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }

  function init(root) {
    var D = window.WordUpDefinition;
    if (root.dataset.ready || !D || !D.COLLECTIONS) return;
    root.dataset.ready = '1';
    var C = D.COLLECTIONS;
    var FIELDS = D.FIELDS;
    var config = JSON.parse(root.querySelector('[data-wst-config]').textContent);
    var T = config.text;
    var lang = config.locale === 'en' ? 'en' : 'sv';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var layout = $('[data-layout]');
    var stage = $('[data-stage]');
    var cam = $('[data-cam]');
    var shirtEl = $('[data-shirt]');
    var photo = $('[data-photo]');
    var canvas = $('[data-preview]');
    var zoomBtn = $('[data-zoom]');
    var zoomLabel = $('[data-zoom-label]');
    var panel = $('[data-panel]');
    var panes = $$('[data-pane]');
    var success = $('[data-success]');
    var stepBtns = $$('[data-go]');
    var bar = $('[data-bar]');
    var msg = $('[data-msg]');
    var backBtn = $('[data-back]');
    var nextBtn = $('[data-next]');
    var nextLabel = $('[data-next-label]');
    var finalBtn = $('[data-final]');
    var addBtn = $('[data-add]');
    var fieldsEl = $('[data-fields]');
    var chipsEl = $('[data-chips]');
    var collsEl = $('[data-colls]');
    var variantsEl = $('[data-variants]');
    var qtyInput = $('[data-qty-input]');
    var sizesEl = $('.wst__sizes');
    var gift = $('[data-gift]');
    var giftFields = $('[data-gift-fields]');
    var giftMsg = $('[data-gift-msg]');

    var state = { step: 1, coll: C[0], tpl: C[0].templates[0], shirt: 'vit', size: null, view: 'auto' };
    var values = { cls: 'subst.' };
    var phonTouched = false;
    var ownWord = false; // the customer wrote the word (a name) themselves: the dice keeps it

    /* ---------- Values: what the customer wrote, the demo while nothing is written, the reveal of an idea ---------- */
    var current = function () {
      var v = {};
      state.tpl.fields.forEach(function (k) { v[k] = String(values[k] || '').trim(); });
      if (v.kap !== undefined) v.kap = v.kap.replace(/\D/g, '');
      if (v.par !== undefined) v.par = v.par.replace(/\D/g, '');
      return v;
    };
    var isEmpty = function () {
      return state.tpl.fields.every(function (k) { return k === 'cls' || !String(values[k] || '').trim(); });
    };
    var ready = function () { var v = current(); return state.tpl.required.every(function (k) { return v[k]; }); };
    var textLength = function (v) {
      return state.tpl.fields.reduce(function (n, k) { return k === 'cls' ? n : n + String(v[k] || '').length; }, 0);
    };
    var partial = function (full, n) {
      var v = {};
      var left = n;
      state.tpl.fields.forEach(function (k) {
        if (k === 'cls') { v.cls = full.cls; return; }
        var text = String(full[k] || '');
        v[k] = text.slice(0, Math.max(0, left));
        left -= text.length;
      });
      return v;
    };

    // Until the customer writes, the shirt writes the ideas itself: the first version of every idea, then the second…
    var demo = { ex: 0, n: 1, hold: 0 };
    var demoList = function () {
      var out = [];
      var most = Math.max.apply(null, state.coll.examples.map(function (x) { return x.list.length; }));
      for (var i = 0; i < most; i++) state.coll.examples.forEach(function (x) { if (x.list[i]) out.push(x.list[i]); });
      return out;
    };
    var demoFull = function () {
      var list = demoList();
      var full = Object.assign({ cls: 'subst.' }, list[demo.ex % list.length]);
      if (full.word) full.phon = D.phonetic(full.word);
      return full;
    };
    var resetDemo = function () { demo.ex = 0; demo.n = reduceMotion ? 999 : 1; demo.hold = 0; };
    var reveal = null; // an idea that was just picked writes itself onto the shirt, quickly

    var shown = function () {
      if (isEmpty()) return partial(demoFull(), demo.n);
      if (reveal) return partial(current(), reveal.n);
      return current();
    };
    var fullText = function () { return isEmpty() ? demoFull() : current(); };

    /* ---------- The camera ----------
       The zoom changes the real size of the shirt (left, top, width, height), not a CSS scale, so the photo and the
       text are drawn at the size they are shown at and stay sharp (a scaled layer gets blurry, especially in Safari). */
    var camera = { S: 0, x: 0, y: 0, k: 1, tx: 0, ty: 0, frac: 0.5 };
    var measureCanvas = document.createElement('canvas');
    measureCanvas.width = 300;
    measureCanvas.height = 400;
    var measure = function (v) {
      var ctx = measureCanvas.getContext('2d');
      return D.draw(ctx, 300, v, state.tpl, '#000').h / 300;
    };
    var isClose = function () { return state.view === 'close' || (state.view === 'auto' && state.step === 2); };
    var layoutCam = function () {
      var sw = stage.clientWidth;
      var sh = stage.clientHeight;
      if (!sw || !sh) return;
      var S = Math.min(sw, sh);
      camera.S = S;
      camera.x = (sw - S) / 2;
      camera.y = (sh - S) / 2;
      camera.k = 0; // forces frame() to place the shirt again
    };
    var frame = function () {
      var close = isClose();
      root.classList.toggle('is-close', close);
      if (zoomLabel) zoomLabel.textContent = close ? T.zoomOut : T.zoomIn;
      var sw = stage.clientWidth;
      var sh = stage.clientHeight;
      if (!camera.S) return;
      var S = camera.S;
      var k = 1, tx = 0, ty = 0;
      if (close) {
        var pw = 0.385 * S, px = 0.31 * S, py = 0.17 * S;
        var ch = Math.max(camera.frac, 0.42) * pw;
        // Phones fill the width with the print; big screens keep some shirt around it.
        var room = sw > 600 ? 1.5 : 1.16;
        k = Math.max(1, Math.min(sw / (pw * room), sh / (ch + pw * 0.22 * room), 4.2));
        tx = sw / 2 - camera.x - k * (px + pw / 2);
        ty = sh / 2 - camera.y - k * (py + ch / 2);
      }
      if (Math.abs(k - camera.k) > 0.02 || Math.abs(tx - camera.tx) > 1.5 || Math.abs(ty - camera.ty) > 1.5) {
        camera.k = k; camera.tx = tx; camera.ty = ty;
        cam.style.setProperty('--cam-s', (S * k).toFixed(1) + 'px');
        cam.style.setProperty('--cam-x', (camera.x + tx).toFixed(1) + 'px');
        cam.style.setProperty('--cam-y', (camera.y + ty).toFixed(1) + 'px');
      }
    };

    /* ---------- Drawing the shirt ---------- */
    var draw = function () {
      var w = canvas.clientWidth;
      if (!w) return;
      // Full screen sharpness (iPhones are 3×), never more than the print file itself.
      var ratio = Math.min(window.devicePixelRatio || 1, 3);
      var bw = Math.min(Math.round(w * ratio), D.PRINT.w);
      if (canvas.width !== bw) {
        canvas.width = bw;
        canvas.height = Math.round(bw * D.PRINT.h / D.PRINT.w);
      }
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      D.draw(ctx, canvas.width, shown(), state.tpl, D.INK[state.shirt]);
    };
    var lastFrac = null;
    var render = function () {
      draw();
      // The camera frames the whole text (also the parts the demo has not written yet), so it does not wander.
      var frac = measure(fullText());
      if (lastFrac === null || Math.abs(frac - lastFrac) > 0.03) { lastFrac = frac; camera.frac = frac; }
      frame();
    };

    var visible = true;
    if (window.IntersectionObserver) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(stage);
    setInterval(function () {
      if (!visible) return;
      if (reveal) {
        reveal.n += 3;
        if (reveal.n >= reveal.total) reveal = null;
        draw();
        return;
      }
      if (!isEmpty() || reduceMotion) return;
      var total = textLength(demoFull());
      if (demo.n < total) demo.n += 1;
      else if ((demo.hold += 1) > 45) { demo.ex += 1; demo.n = 1; demo.hold = 0; render(); return; }
      draw();
    }, 60);

    /* ---------- Small prints on the collection cards ---------- */
    var minis = [];
    var drawMini = function (c, cv) {
      var w = cv.clientWidth;
      if (!w) return;
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(w * ratio);
      cv.height = Math.round(w * ratio * 0.75);
      var ctx = cv.getContext('2d');
      ctx.fillStyle = '#F7F7F5';
      ctx.fillRect(0, 0, cv.width, cv.height);
      var pw = cv.width * 0.6;
      var ex = Object.assign({ cls: 'subst.' }, c.examples[0].list[0]);
      if (ex.word) ex.phon = D.phonetic(ex.word);
      ctx.save();
      ctx.translate((cv.width - pw) / 2, cv.height * 0.14);
      D.draw(ctx, pw, ex, c.templates[0], '#161616');
      ctx.restore();
    };

    /* ---------- 1 Stil ---------- */
    var buildColls = function () {
      minis = [];
      collsEl.replaceChildren.apply(collsEl, C.map(function (c) {
        var cv = el('canvas', { 'aria-hidden': 'true' });
        minis.push([c, cv]);
        var b = el('button', { type: 'button', role: 'radio', class: 'wst__coll', 'aria-checked': String(c === state.coll) }, [
          cv,
          el('span', { class: 'wst__coll-name', text: (lang === 'en' && D.EN_NAMES[c.key]) || c.name }),
          el('span', { class: 'wst__coll-desc', text: (T.collDesc && T.collDesc[c.key]) || '' }),
        ]);
        b.addEventListener('click', function () { setCollection(c); });
        return b;
      }));
      D.fontsReady.then(function () { minis.forEach(function (m) { drawMini(m[0], m[1]); }); });
    };
    var buildVariants = function () {
      var buttons = state.coll.templates.map(function (t) {
        var b = el('button', { type: 'button', role: 'radio', 'aria-checked': String(t === state.tpl), text: t.name[lang] || t.name.sv });
        b.addEventListener('click', function () { setTemplate(t); });
        return b;
      });
      var seg = el('div', { class: 'wst__seg', role: 'radiogroup', 'aria-label': T.variant }, buttons);
      seg.style.setProperty('--n', buttons.length);
      variantsEl.replaceChildren(el('span', { class: 'wst__label', text: T.variant }), seg);
      variantsEl.hidden = state.coll.templates.length < 2;
    };
    // The main text of each collection: what the customer wrote follows along to the other collection
    // (an idea they only picked stays behind, it belongs to its own collection).
    var MAIN = { ord: 'def', lag: 'law' };
    var setCollection = function (c) {
      if (c === state.coll) return;
      var from = MAIN[state.coll.key], to = MAIN[c.key];
      var text = String(values[from] || '').trim();
      if (from && to && text && !idea.x) values[to] = text.slice(0, FIELDS[to].max);
      state.coll = c;
      state.tpl = c.templates[0];
      idea.x = null;
      $$('.wst__coll').forEach(function (b, i) { b.setAttribute('aria-checked', String(C[i] === c)); });
      resetDemo();
      buildVariants();
      buildFields();
      buildChips();
      render();
      save();
    };
    var setTemplate = function (t) {
      state.tpl = t;
      resetDemo();
      buildVariants();
      buildFields();
      render();
      save();
    };

    /* ---------- 2 Text ---------- */
    var EXTRA = ['phon', 'cls', 'kap'];
    var moreOpen = false;
    var buildFields = function () {
      var order = state.tpl.required.concat(state.tpl.fields.filter(function (k) { return state.tpl.required.indexOf(k) < 0; }));
      var labels = order.map(function (k) {
        var f = FIELDS[k];
        var input;
        if (f.type === 'select') {
          input = el('select', { 'data-k': k }, f.options.map(function (o) { return el('option', { value: o, text: o }); }));
          input.value = values[k] || f.options[0];
        } else {
          input = el(f.type === 'textarea' ? 'textarea' : 'input', {
            'data-k': k,
            maxlength: f.max,
            rows: f.type === 'textarea' ? 2 : null,
            autocomplete: 'off',
            autocapitalize: k === 'word' ? 'off' : null,
            spellcheck: f.spell === false ? 'false' : null,
            inputmode: f.numeric ? 'numeric' : null,
            enterkeyhint: 'done',
            placeholder: (T.placeholders && T.placeholders[k]) || null,
          });
          input.value = values[k] || '';
        }
        var count = f.max && !f.numeric ? el('span', { class: 'wst__count', 'aria-hidden': 'true' }) : null;
        var label = el('label', { class: 'wst__field' + (k === 'word' ? ' is-word' : '') + (f.numeric ? ' is-short' : '') }, [
          el('span', { class: 'wst__label' }, [T.fields[k] || k, count]),
          input,
        ]);
        label.dataset.field = k;
        if (count) setCount(input, count);
        return label;
      });
      var main = labels.filter(function (l) { return EXTRA.indexOf(l.dataset.field) < 0; });
      var extra = labels.filter(function (l) { return EXTRA.indexOf(l.dataset.field) > -1; });
      var children = main.slice();
      if (extra.length) {
        var more = el('details', { class: 'wst__more' }, [
          el('summary', { text: state.coll.key === 'ord' ? T.moreOrd : T.moreLag }),
          el('div', { class: 'wst__more-fields' }, extra),
        ]);
        more.open = moreOpen;
        more.addEventListener('toggle', function () { moreOpen = more.open; });
        children.push(more);
      }
      fieldsEl.replaceChildren.apply(fieldsEl, children);
    };
    var setCount = function (input, count) {
      count = count || input.parentNode.querySelector('.wst__count');
      var f = FIELDS[input.dataset.k];
      if (!count || !f || !f.max) return;
      count.textContent = input.value.length + '/' + f.max;
      count.classList.toggle('is-full', input.value.length >= f.max);
    };
    fieldsEl.addEventListener('input', function (event) {
      var k = event.target.dataset.k;
      if (!k) return;
      if (event.target.tagName === 'TEXTAREA') event.target.value = D.clean(event.target.value);
      values[k] = event.target.value;
      reveal = null;
      setCount(event.target);
      var label = event.target.closest('.wst__field');
      if (label) label.classList.remove('is-missing');
      if (k === 'word') ownWord = event.target.value.trim() !== '';
      if (k === 'phon') phonTouched = event.target.value !== '' && event.target.value !== D.phonetic(values.word || '');
      if (k === 'word' && !phonTouched) {
        // The pronunciation follows the word until the customer writes their own.
        values.phon = D.phonetic(event.target.value);
        var phon = fieldsEl.querySelector('[data-k="phon"]');
        if (phon) { phon.value = values.phon; setCount(phon); }
      }
      if (idea.x) { idea.x = null; buildChips(); }
      render();
      save();
    });
    fieldsEl.addEventListener('change', function (event) {
      var k = event.target.dataset.k;
      if (k) { values[k] = event.target.value; render(); save(); }
    });

    // Ideas: a theme button fills in its first version, the same button (or "Visa en till") the next one.
    var idea = { x: null, i: 0 };
    var useIdea = function (x, i, keepWord) {
      idea.x = x;
      idea.i = i % x.list.length;
      var v = Object.assign({}, x.list[idea.i]);
      var word = values.word;
      var phon = values.phon;
      state.tpl.fields.forEach(function (k) { if (k !== 'cls') values[k] = ''; });
      if (keepWord && v.word !== undefined) { v.word = word; }
      else ownWord = false;
      Object.assign(values, v);
      if (keepWord && v.word !== undefined) values.phon = phonTouched ? phon : D.phonetic(word);
      else if (v.word !== undefined) { values.phon = D.phonetic(v.word); phonTouched = false; }
      reveal = reduceMotion ? null : { n: 0, total: textLength(current()) };
      if (keepWord) idea.x = null; // the theme buttons stay as they were; the word is the customer's own
      buildChips();
      buildFields();
      render();
      save();
    };
    var buildChips = function () {
      if (idea.x && state.coll.examples.indexOf(idea.x) < 0) idea.x = null;
      var buttons = state.coll.examples.map(function (x) {
        var on = x === idea.x;
        var b = el('button', { type: 'button', 'aria-pressed': String(on), text: x.label });
        b.addEventListener('click', function () { useIdea(x, on ? idea.i + 1 : 0); });
        return b;
      });
      var row = [el('span', { class: 'wst__label wst__chips-label', text: T.ideas }), el('div', { class: 'wst__chips' }, buttons)];
      if (idea.x && idea.x.list.length > 1) {
        var again = el('button', { type: 'button', class: 'wst__another' }, [
          T.another + ' → ',
          el('span', { text: (idea.i + 1) + '/' + idea.x.list.length }),
        ]);
        again.addEventListener('click', function () { useIdea(idea.x, idea.i + 1); });
        row.push(again);
      }
      chipsEl.replaceChildren.apply(chipsEl, row);
    };
    var dice = $('[data-dice]');
    // Meanings that describe a person ("den som …", "en person …") fit after a name the customer wrote.
    var PERSON = /^(den |någon |en (person|man |kvinna|familjemedlem|sambo|personlig))/;
    dice.addEventListener('click', function () {
      var keep = ownWord && !!String(values.word || '').trim();
      var picks = [];
      state.coll.examples.forEach(function (x) {
        x.list.forEach(function (v, i) {
          if (keep && v.word !== undefined && !PERSON.test(v.def || '')) return;
          if (x === idea.x && i === idea.i) return;
          picks.push([x, i]);
        });
      });
      var pick = picks[Math.floor(Math.random() * picks.length)] || [state.coll.examples[0], 0];
      var x = pick[0], i = pick[1];
      dice.classList.remove('is-rolling');
      void dice.offsetWidth;
      dice.classList.add('is-rolling');
      // A name the customer wrote stays; only the meaning is new (a name + a funny definition).
      useIdea(x, i, keep);
    });

    /* ---------- 3 Tröja ---------- */
    var variantFor = function (size) {
      var names = D.COLOR_NAMES[state.shirt];
      return (config.variants || []).find(function (v) {
        return names.indexOf(String(v.options[config.colorIndex]).toLowerCase()) > -1 && v.options[config.sizeIndex] === size;
      });
    };
    var markSizes = function () {
      $$('[data-size]').forEach(function (b) {
        var v = variantFor(b.dataset.size);
        b.disabled = !v || !v.available;
        if (b.disabled && state.size === b.dataset.size) state.size = null;
        b.setAttribute('aria-checked', String(state.size === b.dataset.size));
      });
    };
    var photoFor = function (s) { return photo.dataset['photo' + s.charAt(0).toUpperCase() + s.slice(1)]; };
    ['vit', 'svart', 'marin'].forEach(function (s) { var img = new Image(); img.src = photoFor(s); });
    var flipN = 0;
    var turn = function (from, to, duration, easing) {
      return shirtEl.animate(
        [{ transform: 'perspective(1400px) rotateY(' + from + 'deg)' }, { transform: 'perspective(1400px) rotateY(' + to + 'deg)' }],
        { duration: duration, easing: easing, fill: 'forwards' }
      );
    };
    // A new colour: the shirt turns a quarter away, changes, and turns back.
    var setShirt = function (s, animate) {
      if (!D.INK[s]) return;
      var changed = s !== state.shirt;
      state.shirt = s;
      $$('[data-s]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.s === s)); });
      markSizes();
      save();
      if (!animate || !changed || reduceMotion || !shirtEl.animate) { photo.src = photoFor(s); render(); return; }
      var id = ++flipN;
      var out = turn(0, 90, 200, 'cubic-bezier(.5,0,.75,0)');
      Promise.race([out.finished.catch(noop), wait(260)]).then(function () {
        if (id !== flipN) return;
        photo.src = photoFor(s);
        render();
        var decoded = photo.decode ? photo.decode().catch(noop) : Promise.resolve();
        return Promise.race([decoded, wait(300)]).then(function () {
          if (id !== flipN) return;
          out.cancel();
          var back = turn(-90, 0, 340, 'cubic-bezier(.2,.7,.2,1)');
          Promise.race([back.finished.catch(noop), wait(420)]).then(function () { if (id === flipN) back.cancel(); });
        });
      });
    };
    $$('[data-s]').forEach(function (b) { b.addEventListener('click', function () { setShirt(b.dataset.s, true); }); });
    $$('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.size = b.dataset.size;
        sizesEl.classList.remove('is-missing');
        markSizes();
        warm();
        save();
      });
    });
    var qty = function () { return Math.min(25, Math.max(1, parseInt(qtyInput.value, 10) || 1)); };
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.min(25, Math.max(1, qty() + Number(b.dataset.qty))); price(); });
    });
    qtyInput.addEventListener('input', price);
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); price(); });
    gift.addEventListener('change', function () { giftFields.hidden = !gift.checked; });
    giftMsg.addEventListener('input', function () { $('[data-gift-count]').textContent = giftMsg.value.length + '/' + giftMsg.maxLength; });

    /* ---------- Price in the bar ---------- */
    function money(cents) {
      var format = config.money || '{{amount_no_decimals}} kr';
      var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
        var n = cents / 100;
        var fixed = n.toFixed(2);
        if (kind.indexOf('no_decimals') > -1) fixed = String(Math.round(n));
        if (kind.indexOf('comma') > -1) fixed = fixed.replace('.', ',');
        return fixed.replace(/[.,]00$/, '');
      });
      return out.replace(/<[^>]*>/g, '');
    }
    function price() {
      var n = qty();
      var strong = $('[data-price]');
      var note = $('[data-price-note]');
      if (n >= 2) { strong.textContent = money(config.pairPrice * n); note.textContent = n + ' × ' + T.pairOn; }
      else { strong.textContent = money(config.price); note.textContent = T.pairNote; }
    }

    /* ---------- Steps ---------- */
    var msgTimer;
    var say = function (text) {
      msg.textContent = text;
      msg.classList.add('is-on');
      clearTimeout(msgTimer);
      msgTimer = setTimeout(function () { msg.classList.remove('is-on'); }, 3400);
    };
    var flagMissing = function () {
      var v = current();
      var missing = state.tpl.required.filter(function (k) { return !v[k]; });
      missing.forEach(function (k) {
        var label = fieldsEl.querySelector('[data-field="' + k + '"]');
        if (label) { label.classList.remove('is-missing'); void label.offsetWidth; label.classList.add('is-missing'); }
      });
      return missing;
    };
    var desktop = window.matchMedia('(min-width: 900px)');
    var scrollToSteps = function () {
      var top = parseFloat(getComputedStyle(root).getPropertyValue('--wst-top')) || 0;
      var behavior = reduceMotion ? 'auto' : 'smooth';
      if (desktop.matches) {
        var target = $('[data-steps]').getBoundingClientRect().top + window.scrollY - top - 24;
        if (window.scrollY > target + 2) window.scrollTo({ top: Math.max(0, target), behavior: behavior });
        return;
      }
      // Phones: the studio is one screen; the new step starts at the top of its own scroll area.
      panel.scrollTop = 0;
      var studioTop = root.getBoundingClientRect().top + window.scrollY - top;
      if (Math.abs(window.scrollY - studioTop) > 2) window.scrollTo({ top: Math.max(0, studioTop), behavior: behavior });
    };
    var go = function (n, opts) {
      opts = opts || {};
      n = Math.min(3, Math.max(1, Number(n) || 1));
      if (n === 3 && !ready()) {
        n = 2;
        if (!opts.quiet) say(T.empty);
        if (state.step === 2 && !opts.quiet) flagMissing();
      }
      var from = state.step;
      state.step = n;
      state.view = 'auto';
      root.dataset.step = n;
      root.style.setProperty('--step', n);
      panes.forEach(function (p) { p.hidden = Number(p.dataset.pane) !== n; });
      success.hidden = true;
      bar.hidden = false;
      stepBtns.forEach(function (b) {
        var i = Number(b.dataset.go);
        if (i === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        b.classList.toggle('is-done', i < n);
      });
      backBtn.hidden = n === 1;
      nextBtn.hidden = n === 3;
      finalBtn.hidden = n !== 3;
      nextLabel.textContent = n === 1 ? T.nextText : T.nextShirt;
      if (n === 2) buildChips();
      render();
      save();
      // Each step is a history entry, so the phone's back gesture goes to the step before instead of leaving Studios.
      if (from !== n && !opts.init && !opts.pop && window.history.pushState) {
        window.history.pushState(Object.assign({}, window.history.state, { wst: n }), '');
      }
      if (from !== n && !opts.init) {
        scrollToSteps();
        var h = panes[n - 1].querySelector('.wst__step-h');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
    };
    stepBtns.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.dataset.go)); }); });
    window.addEventListener('popstate', function (event) {
      var n = (event.state && event.state.wst) || 1;
      if (typing) exitTyping();
      go(n, { pop: true, quiet: true });
    });
    nextBtn.addEventListener('click', function () { go(state.step + 1); });
    backBtn.addEventListener('click', function () { go(Math.max(1, state.step - 1)); });
    zoomBtn.addEventListener('click', function () {
      state.view = isClose() ? 'full' : 'close';
      frame();
    });

    /* ---------- Phones: pinned above the keyboard while writing ---------- */
    var vv = window.visualViewport;
    var touch = window.matchMedia('(max-width: 899px) and (pointer: coarse)');
    var typing = false;
    var typingY = 0;
    var syncViewport = function () {
      root.style.setProperty('--vvh', vv.height + 'px');
      root.style.setProperty('--vvt', vv.offsetTop + 'px');
    };
    var keepField = function () {
      var a = document.activeElement;
      if (!typing || !a || !panel.contains(a)) return;
      var p = panel.getBoundingClientRect();
      var r = (a.closest('.wst__field') || a).getBoundingClientRect();
      if (r.top < p.top + 8) panel.scrollTop -= p.top + 8 - r.top;
      else if (r.bottom > p.bottom - 8) panel.scrollTop += r.bottom - (p.bottom - 8);
    };
    var onViewport = function () { syncViewport(); keepField(); };
    var enterTyping = function () {
      if (typing || !touch.matches || !vv) return;
      typing = true;
      typingY = window.scrollY;
      root.style.minHeight = root.offsetHeight + 'px';
      syncViewport();
      root.classList.add('is-typing');
      vv.addEventListener('resize', onViewport);
      vv.addEventListener('scroll', onViewport);
      setTimeout(keepField, 60);
      setTimeout(onViewport, 350);
    };
    var exitTyping = function () {
      if (!typing) return;
      typing = false;
      vv.removeEventListener('resize', onViewport);
      vv.removeEventListener('scroll', onViewport);
      root.classList.remove('is-typing');
      root.style.minHeight = '';
      panel.scrollTop = 0;
      // Back to where the page was before the keyboard came up (iOS may have scrolled it meanwhile).
      requestAnimationFrame(function () { window.scrollTo(0, typingY); });
    };
    var isTextInput = function (node) {
      return node && panel.contains(node) && node.matches('input:not([type="checkbox"]), textarea, select');
    };
    panel.addEventListener('focusin', function (event) {
      if (isTextInput(event.target) && !event.target.matches('select')) enterTyping();
      else if (typing) keepField();
    });
    root.addEventListener('focusout', function () {
      setTimeout(function () { if (typing && !isTextInput(document.activeElement)) exitTyping(); }, 160);
    });
    $('[data-done]').addEventListener('click', function () { if (document.activeElement) document.activeElement.blur(); exitTyping(); });
    fieldsEl.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      // Enter in a word field closes it; in a text it makes a new line (at most three, see D.clean).
      if (event.target.matches('input')) { event.preventDefault(); event.target.blur(); }
    });

    /* ---------- The header: the studio sticks right under it ---------- */
    var header = document.querySelector('.section-header');
    var measureTop = function () {
      var sticky = header && /sticky|fixed/.test(getComputedStyle(header).position);
      root.style.setProperty('--wst-top', (sticky ? header.offsetHeight : 0) + 'px');
    };
    measureTop();
    if (window.ResizeObserver) {
      if (header) new ResizeObserver(measureTop).observe(header);
      new ResizeObserver(function () { layoutCam(); render(); }).observe(stage);
      // The print is redrawn at its new size while the camera zooms (once per frame at most).
      var redraw = 0;
      new ResizeObserver(function () {
        if (redraw) return;
        redraw = requestAnimationFrame(function () { redraw = 0; draw(); });
      }).observe(canvas);
      new ResizeObserver(function () { minis.forEach(function (m) { drawMini(m[0], m[1]); }); }).observe(collsEl);
    } else {
      window.addEventListener('resize', function () { measureTop(); layoutCam(); render(); });
    }

    /* ---------- Remember the draft in this tab (back from the cart, reload) ---------- */
    var KEY = 'wst-draft';
    var saveTimer;
    function save() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        try {
          sessionStorage.setItem(KEY, JSON.stringify({
            coll: state.coll.key, tpl: state.tpl.key, shirt: state.shirt, size: state.size, step: state.step,
            values: values, phonTouched: phonTouched, ownWord: ownWord,
          }));
        } catch (e) {}
      }, 250);
    }

    /* ---------- Add to cart ---------- */
    var upload = function (blob) {
      if (!config.printUpload) return Promise.reject(new Error('no upload'));
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 45000);
      return fetch(config.printUpload, { method: 'POST', headers: { 'Content-Type': 'image/png' }, body: blob, signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
        .then(function (json) { if (!json.url) throw new Error('no url'); return json.url; })
        .finally(function () { clearTimeout(timer); });
    };
    var prepared = { sig: null, promise: null };
    var prepare = function () {
      var v = current();
      var tpl = state.tpl;
      var ink = D.INK[state.shirt];
      var sig = JSON.stringify([state.coll.key, tpl.key, ink, v]);
      if (prepared.sig === sig) return prepared.promise;
      prepared.sig = sig;
      prepared.promise = D.fontsReady.then(function () {
        var file = document.createElement('canvas');
        file.width = D.PRINT.w;
        file.height = D.PRINT.h;
        var size = D.draw(file.getContext('2d'), D.PRINT.w, v, tpl, ink);
        return new Promise(function (r) { file.toBlob(r, 'image/png'); }).then(function (blob) {
          // Without a file the shirt is still added; studios-flow marks it for the team to print by hand.
          return upload(blob).catch(function () { return ''; }).then(function (url) { return { url: url, size: size }; });
        });
      });
      return prepared.promise;
    };
    function warm() { if (addBtn && ready()) prepare(); }
    if (addBtn) {
      addBtn.addEventListener('pointerenter', warm);
      addBtn.addEventListener('focus', warm);
    }

    var updateCart = function (sections) {
      sections = sections || {};
      var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
      var bubble = document.getElementById('cart-icon-bubble');
      var freshBubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      var freshDrawer = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
      var target = document.getElementById('CartDrawer');
      if (drawer && freshDrawer && target) {
        target.innerHTML = freshDrawer.innerHTML;
        drawer.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    };
    $('[data-view-cart]').addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.open && document.getElementById('CartDrawer')) drawer.open();
      else window.location.href = config.cartUrl || '/cart';
    });

    var party = $('[data-party]');
    var celebrate = function (count) {
      panes.forEach(function (p) { p.hidden = true; });
      bar.hidden = true;
      success.hidden = false;
      $('[data-success-pair]').hidden = count >= 2;
      stepBtns.forEach(function (b) { b.removeAttribute('aria-current'); b.classList.add('is-done'); });
      root.style.setProperty('--step', 3);
      state.view = 'full';
      frame();
      scrollToSteps();
      var h = $('[data-success-h]');
      if (h) h.focus({ preventScroll: true });
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      if (reduceMotion) return;
      var colors = ['#B4532A', '#09111D', '#E2A786', '#C9CED6', '#09111D', '#B4532A'];
      for (var i = 0; i < 26; i++) {
        var a = Math.random() * Math.PI * 2;
        var d = 90 + Math.random() * 170;
        var bit = el('span', { class: 'wst__bit' });
        bit.style.setProperty('--c', colors[i % colors.length]);
        bit.style.setProperty('--dx', Math.cos(a) * d + 'px');
        bit.style.setProperty('--dy', Math.sin(a) * d - 40 + 'px');
        bit.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
        bit.style.animationDelay = Math.random() * 120 + 'ms';
        party.appendChild(bit);
      }
      setTimeout(function () { party.replaceChildren(); }, 1600);
      if (shirtEl.animate) shirtEl.animate(
        [{ transform: 'translateY(0) scale(1)' }, { transform: 'translateY(-3%) scale(1.02)' }, { transform: 'translateY(0) scale(1)' }],
        { duration: 520, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    };
    $('[data-again]').addEventListener('click', function () {
      state.tpl.fields.forEach(function (k) { if (k !== 'cls') values[k] = ''; });
      phonTouched = false;
      idea.x = null;
      reveal = null;
      qtyInput.value = 1;
      gift.checked = false;
      giftFields.hidden = true;
      giftMsg.value = '';
      price();
      resetDemo();
      buildFields();
      go(2);
    });

    if (addBtn) addBtn.addEventListener('click', function () {
      if (addBtn.classList.contains('is-busy')) return;
      if (!ready()) { go(2); return; }
      if (!state.size) {
        say(T.chooseSize);
        sizesEl.classList.remove('is-missing');
        void sizesEl.offsetWidth;
        sizesEl.classList.add('is-missing');
        return;
      }
      var variant = variantFor(state.size);
      if (!variant || !variant.available) { say(T.soldOut); return; }

      addBtn.classList.add('is-busy');
      addBtn.setAttribute('aria-busy', 'true');
      var v = current();
      var tpl = state.tpl;
      var coll = state.coll;
      var ink = D.INK[state.shirt];
      var count = qty();
      prepare().then(function (print) {
        // Customer-facing lines in Swedish (the team reads them the same in every language); "_" keys are hidden.
        var props = { Kollektion: coll.name };
        tpl.fields.forEach(function (k) {
          if (!v[k]) return;
          var hidden = ['phon', 'cls', 'kap'].indexOf(k) > -1;
          props[(hidden ? '_' : '') + FIELDS[k].prop] = k === 'par' ? '§' + v[k] : v[k];
        });
        props['_Mall-namn'] = coll.name + ', ' + tpl.name.sv;
        if (gift.checked) {
          props.Present = 'Ja';
          if (giftMsg.value.trim()) props['Hälsning'] = giftMsg.value.trim();
        }
        props._Mall = 'definition-' + coll.key + '-' + tpl.key;
        props['_Printful-typsnitt'] = coll.key === 'lag' ? 'Cormorant Garamond' : 'Newsreader, Cormorant Garamond';
        props['_Printful-färg'] = ink;
        props._Tryckbredd = 'ca ' + Math.round(print.size.w * D.CM_PER_PX) + ' × ' + Math.round(print.size.h * D.CM_PER_PX) + ' cm';
        if (print.url) props._Tryckfil = print.url;
        var sectionIds = document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: count, properties: props }],
            sections: sectionIds,
            sections_url: window.location.pathname,
          }),
        }).then(function (r) { return r.json().then(function (json) { if (!r.ok || json.status) throw new Error(json.description || json.message); return json; }); });
      }).then(function (json) {
        updateCart(json.sections);
        celebrate(count);
      }).catch(function (e) {
        say((e && e.message) || T.error);
      }).finally(function () {
        addBtn.classList.remove('is-busy');
        addBtn.removeAttribute('aria-busy');
      });
    });

    /* ---------- Start: text from the home page (?mall=&typ=&farg=&f_…), a draft from this tab, or the beginning ---------- */
    var q = new URLSearchParams(window.location.search);
    var draft = null;
    try { draft = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    var fromHome = false;
    q.forEach(function (value, key) {
      var k = key.slice(2);
      if (key.indexOf('f_') === 0 && FIELDS[k]) { values[k] = value.slice(0, FIELDS[k].max || 20); fromHome = true; }
    });
    var startStep = 1;
    var collKey = q.get('mall');
    var tplKey = q.get('typ');
    var shirtKey = q.get('farg') || 'vit';
    if (fromHome) {
      if (window.history.replaceState) window.history.replaceState(null, '', window.location.pathname);
      ownWord = !!values.word; // the name typed on the home page
      if (values.phon && values.phon !== D.phonetic(values.word || '')) phonTouched = true;
      startStep = 2;
    } else if (draft && draft.values) {
      values = Object.assign({ cls: 'subst.' }, draft.values);
      phonTouched = !!draft.phonTouched;
      ownWord = !!draft.ownWord;
      collKey = collKey || draft.coll;
      tplKey = tplKey || draft.tpl;
      shirtKey = q.get('farg') || draft.shirt || 'vit';
      state.size = draft.size || null;
      startStep = draft.step || 1;
    }
    state.coll = C.find(function (c) { return c.key === collKey; }) || C[0];
    state.tpl = state.coll.templates.find(function (t) { return t.key === tplKey; }) || state.coll.templates[0];
    resetDemo();
    buildColls();
    buildVariants();
    buildFields();
    buildChips();
    setShirt(shirtKey, false);
    price();
    layoutCam();
    go(startStep, { init: true, quiet: true });
    if (window.history.replaceState) window.history.replaceState(Object.assign({}, window.history.state, { wst: state.step }), '');
    D.fontsReady.then(render);
  }

  var start = function () { document.querySelectorAll('[data-wst]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
